import {
  CreateTicketTemplateInput,
  GetAllTicketsTemplateResponseSchema,
  GetQueryProps,
  UpdateTicketTemplateInput,
} from "shared";
import { axiosClient, fetchCall } from "utilz";
import {
  apiErrorHandler,
  generateUrlString,
  getMspId,
  getQueryDataObject,
  validateApiResponse,
} from "utilz/helpers";

export const getAllTicketTemplates = async ({
  perPageCount,
  pageNumber,
  sortColumn,
  sortDirection = "asc",
  filter,
  searchQuery,
}: GetQueryProps) => {
  try {
    const data = await getQueryDataObject({
      perPageCount,
      pageNumber,
      sortColumn,
      sortDirection,
      filter,
      searchQuery,
    });

    const url = await generateUrlString({
      baseUrl: "v2/configuration/ticket_template",
      data,
    });

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      const result = validateApiResponse({
        response: response,
        schema: GetAllTicketsTemplateResponseSchema,
      });
      return result;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }

  // console.log(response.data);
};

// get template by id
export const getTicketTemplateById = async (templateId: string) => {
  try {
    const url = `v2/configuration/ticket_template/${templateId}`;

    const response = await axiosClient.get(`${url}`);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }

  // console.log(response.data);
};

export const createTicketTemplate = async (
  inputData: CreateTicketTemplateInput
) => {
  try {
    const data = {
      template_summary: inputData.summary,
      template_description: inputData.description,
      template_name: inputData.templateName,
      board_id: inputData.board,
      priority: inputData.priority,
      is_billable: inputData.isBillable,
      ...(inputData.urgency && { urgency: inputData.urgency }),
      ...(inputData.workType && { work_type_id: inputData.workType }),
      ticket_type_id: inputData.ticketType,
      ticket_status: inputData.status,
      ticket_subtype_id: inputData.ticketSubtype,
      source_id: inputData.source,
      impact: inputData.impact,

      budgeted_hours: inputData.budgetedHours,
      contract_id: inputData.contract,
      sla_id: inputData.sla,

      checklists: inputData.checklist,
      attachments: inputData.attachments,
      estimated_end_date: inputData.estimatedEndTime,
      ...(inputData.tags &&
        inputData.tags.length > 0 && { tags: inputData.tags }),

      show_user: inputData.showUser,
    };

    const url = "/configuration/create/ticket_template/sdsdf";
    const response = await axiosClient.post(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const updateTicketTemplate = async (
  inputData: UpdateTicketTemplateInput
) => {
  try {
    const data = {
      template_summary: inputData.summary,
      template_description: inputData.description,
      template_name: inputData.templateName,
      board_id: inputData.board,
      priority: inputData.priority,
      is_billable: inputData.isBillable,
      ...(inputData.urgency && { urgency: inputData.urgency }),
      ...(inputData.workType && { work_type_id: inputData.workType }),
      ticket_type_id: inputData.ticketType,
      ticket_status: inputData.status,
      ticket_subtype_id: inputData.ticketSubtype,
      source_id: inputData.source,
      impact: inputData.impact,

      budgeted_hours: inputData.budgetedHours,
      contract_id: inputData.contract,
      sla_id: inputData.sla,

      checklists: inputData.checklist,
      attachments: inputData.attachments,
      estimated_end_date: inputData.estimatedEndTime,

      ...(inputData.tags &&
        inputData.tags.length > 0 && { tags: inputData.tags }),

      show_user: inputData.showUser,
    };

    const url = `/v2/configuration/ticket_template/${inputData.templateId}`;
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};

export const deleteTicketTemplates = async (data: {
  templates: Array<string>;
}) => {
  try {
    const url = "/v2/configuration/ticket-templates";
    const response = await axiosClient.patch(`${url}`, data);
    const resData = response.data;
    if (resData.success && resData.statusCode === 200) {
      return resData.data;
    }
    throw response;
  } catch (error: any) {
    apiErrorHandler(error);
  }
};
